import React from 'react';

const Sharing = () => (
  <svg
    width="18"
    height="20"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.154 6.835a3.046 3.046 0 1 0-2.92-2.175L5.37 8.046a.67.67 0 0 0-.037.024 3.046 3.046 0 1 0 .112 4.385l5.732 3.31a3.046 3.046 0 1 0 .547-1.192L6.141 11.35c.116-.323.18-.67.18-1.034 0-.416-.084-.814-.236-1.176l5.782-3.338a3.039 3.039 0 0 0 2.287 1.033zm0-1.543a1.503 1.503 0 1 0 0-3.006 1.503 1.503 0 0 0 0 3.006zm1.503 11.117a1.503 1.503 0 1 1-3.006 0 1.503 1.503 0 0 1 3.006 0zM4.778 10.317a1.503 1.503 0 1 1-3.007 0 1.503 1.503 0 0 1 3.007 0z"
      fill="currentColor"
    />
  </svg>
);

export default Sharing;
